import { Component, OnInit } from '@angular/core';
import { WorkflowContextService } from 'src/app/services';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'wm-help-view',
    templateUrl: './help-view.component.html',
    styleUrl: './help-view.component.css',
    standalone: false
})
export class HelpViewComponent implements OnInit {
  userGuideLink: any;
  trainingSiteLink = 'https://geopermitstraining.hubs.vidyard.com/'
  contactSupportLink = '';

  constructor(
    private _dataSvc: DataService,
    private _context: WorkflowContextService
  ) {}

  ngOnInit() {
    this.userGuideLink = '';

    this._dataSvc.getUserGuideLink().subscribe(results => {
      this.userGuideLink = results;
    });

    this.contactSupportLink = this._context.contactSupportLink;
  }
}
